import { render, staticRenderFns } from "./PanelistSurveyDashboardPage.vue?vue&type=template&id=f8853ec0"
import script from "./PanelistSurveyDashboardPage.vue?vue&type=script&lang=ts"
export * from "./PanelistSurveyDashboardPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports